import { getToken } from 'firebase/messaging';
import { getErrorReporter } from 'shared/services/error-tracking';
import { ID } from 'shared/types/id';

import { getPushNotificationToken, initPushNotifications } from './helpers';

export const getPushToken = async (uid: ID) => {
  if (!uid) {
    return;
  }

  try {
    const serviceWorkerRegistration =
      await window.navigator.serviceWorker?.ready;

    const messaging = initPushNotifications();

    return (
      getPushNotificationToken(uid) ??
      (await window.electron?.getFcmToken?.()) ??
      (await getToken(messaging, {
        serviceWorkerRegistration,
        vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
      }))
    );
  } catch (error) {
    getErrorReporter().captureException(error, {
      tags: { source: 'get-push-token' },
    });
  }
};
